export const normalizePermission = (permission) =>
   String(typeof permission === "string" ? permission : permission?.name || "")
      .trim()
      .toLowerCase();

export const normalizePermissions = (permissions) =>
   (Array.isArray(permissions) ? permissions : [])
      .map(normalizePermission)
      .filter(Boolean);

export const selectUserPermissions = (state) => {
   const authUser = state?.auth?.user;
   const profile = authUser?.data ?? authUser;
   const user = profile?.user ?? profile;
   const role = user?.role ?? profile?.role;

   return (
      profile?.permissions ??
      user?.permissions ??
      role?.permissions ??
      authUser?.permissions ??
      []
   );
};
